import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import UsageExpiredAlert from '@/components/billing/UsageExpiredAlert';

// Le back applique la limite mais ne l'expose pas dans le DTO webinaire.
export const FREE_REGISTRATION_LIMIT = 10;

type FreeRegistrationLimitBannerProps = {
  registeredAttendeesCount: number | null | undefined;
  limitReached?: boolean;
};

export default function FreeRegistrationLimitBanner({
  registeredAttendeesCount,
  limitReached,
}: FreeRegistrationLimitBannerProps) {
  const { t } = useTranslation('billing');

  if (registeredAttendeesCount == null) return null;

  const current = registeredAttendeesCount;
  const atMax = limitReached ?? current >= FREE_REGISTRATION_LIMIT;
  const percentage = Math.min(100, Math.round((current / FREE_REGISTRATION_LIMIT) * 100));

  return (
    <div className="flex w-full flex-col gap-2">
      <p className="text-sm text-secondary font-base">
        {t('freeRegistrationLimit.usageTitle', { current, max: FREE_REGISTRATION_LIMIT })}
      </p>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-gray-200">
        <div
          className={cn('h-full rounded-full transition-all', atMax ? 'bg-warning' : 'bg-primary')}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div className="flex flex-wrap items-center text-sm text-secondary font-base">
        <span>
          {atMax
            ? t('freeRegistrationLimit.limitReached')
            : t('freeRegistrationLimit.limitInfo', { max: FREE_REGISTRATION_LIMIT })}
        </span>
        {/* Seul ce libellé est cliquable et ouvre la modale de choix de plan. */}
        <UsageExpiredAlert
          isConfig
          triggerLabel={t(atMax ? 'freeRegistrationLimit.ctaReached' : 'freeRegistrationLimit.cta')}
          triggerClassName="ml-1 h-auto bg-transparent p-0 text-sm font-base text-[#2C6CFF] underline shadow-none hover:bg-transparent"
        />
      </div>
    </div>
  );
}
